import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import logo from '../../../assets/images/logo-sq.jpg';
import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import Calculator from '../../../Components/calculator/Calculator';
import { useCreateAnswerMutation, useFinishExamMutation } from '../../../Redux/Apis/userExamApi';
import { useDispatch } from 'react-redux';
import { pauseTimer, resetTimer, resumeTimer, setTimer } from '../../../Redux/Slices/timerSlice';
import { useSelector } from 'react-redux';
import { RootState } from '../../../Redux/Store/Store';
import { safeParseHtml } from '../../../utils/safeParseHtml';

export default function ExamHeader({type,title,id,index,end,answer,info,userExam,resetKey,setKey,examType,dir,setDir,pin,togglePin,examOrder,review,setReview,reviewSelectedOrder,help,setHelp}:any){
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [calc,setCalc] = useState(false);
    const [createAnswer] = useCreateAnswerMutation();
    const [finishExam] = useFinishExamMutation();
    const timer = useSelector((state: RootState) => state.timers[`timer-${userExam}-${type}`]);
    const isQuantNow = () => {
      if (examType === 'QUANT') return true;
      if (examType === 'VERBAL') return false;
      if (examType === 'GENERAL1') {
        // Sections by index: 0(directive) | 1 | 2 | 3 | 4
        const section = index === 1 ? 0 : index <= 13 ? 1 : index <= 25 ? 2 : index <= 41 ? 3 : 4;
        return examOrder === 'VERBAL_QUANT' ? (section === 2 || section === 4) : (section === 1 || section === 3);
      }
      if (examType === 'GENERAL2' || examType === 'GENERAL') {
        // 4 sections of 20 questions each (0-based)
        const sec0 = Math.floor((index - 1) / 20);
        return examOrder === 'VERBAL_QUANT' ? (sec0 === 1 || sec0 === 3) : (sec0 === 0 || sec0 === 2);
      }
      return false;
    }

    useEffect(() => {
      if(timer && type === 'real') {
        switch (examType) {
            case "GENERAL":
                if(timer.remainingTime && timer.remainingTime <= 7800 && timer.remainingTime > 6000) {
                    // console.log("v1");
                    if (index > 20) setDir(21)
                }
                else if(timer.remainingTime && timer.remainingTime <= 6000 && timer.remainingTime > 3900) {
                    // console.log("q1");
                    if (index <= 20) {
                        setDir(21)
                    } else if (index > 40) {
                        setDir(41)
                    }
                }
                else if(timer.remainingTime && timer.remainingTime <= 3900 && timer.remainingTime > 2100) {
                    // console.log("v2");
                    if (index <= 40) {
                        setDir(41)
                    } else if (index > 60) {
                        setDir(61)
                    }
                }
                else if(timer.remainingTime && timer.remainingTime <= 2100 && timer.remainingTime > 0) {
                    // console.log("q2");
                    if (index <= 60) {
                        setDir(61)
                    } else if (index > 80) {
                        setDir(80)
                    }
                }
                break;

            case "GENERAL1":
                if (examOrder === 'VERBAL_QUANT') {
                    if(timer.remainingTime && timer.remainingTime <= 7080 && timer.remainingTime > 5280) {
                        // console.log("w1");
                        if (index > 1) setDir(1.5)
                    }
                    else if(timer.remainingTime && timer.remainingTime <= 5280 && timer.remainingTime > 4200) {
                        // console.log("v1");
                        if (index <= 1) {
                            setDir(1.5)
                        } else if (index > 13) {
                            setDir(21)
                        }
                    }
                    else if(timer.remainingTime && timer.remainingTime <= 4200 && timer.remainingTime > 2940) {
                        // console.log("q1");
                        if (index <= 13) {
                            setDir(21)
                        } else if (index > 25) {
                            setDir(41)
                        }
                    }
                    else if(timer.remainingTime && timer.remainingTime <= 2940 && timer.remainingTime > 1560) {
                        // console.log("v2");
                        if (index <= 25) {
                            setDir(41)
                        } else if (index > 40) {
                            setDir(61)
                        }
                    }
                    else if(timer.remainingTime && timer.remainingTime <= 1560 && timer.remainingTime > 0) {
                        // console.log("q2");
                        if (index <= 40) {
                            setDir(61)
                        } else if (index > 55) {
                            setDir(80)
                        }
                    }
                } else {
                    //quantVerbal
                    if(timer.remainingTime && timer.remainingTime <= 7080 && timer.remainingTime > 5280) {
                        // console.log("w1");
                        if (index > 1) setDir(1.5)
                    }
                    else if(timer.remainingTime && timer.remainingTime <= 5280 && timer.remainingTime > 4020) {
                        // console.log("q1");
                        if (index <= 1) {
                            setDir(1.5)
                        } else if (index > 13) {
                            setDir(21)
                        }
                    }
                    else if(timer.remainingTime && timer.remainingTime <= 4020 && timer.remainingTime > 2940) {
                        // console.log("v1");
                        if (index <= 13) {
                            setDir(21)
                        } else if (index > 25) {
                            setDir(41)
                        }
                    }
                    else if(timer.remainingTime && timer.remainingTime <= 2940 && timer.remainingTime > 1380) {
                        // console.log("q2");
                        if (index <= 25) {
                            setDir(41)
                        } else if (index > 40) {
                            setDir(61)
                        }
                    }
                    else if(timer.remainingTime && timer.remainingTime <= 1380 && timer.remainingTime > 0) {
                        // console.log("v2");
                        if (index <= 40) {
                            setDir(61)
                        } else if (index > 55) {
                            setDir(80)
                        }
                    }
                }
                break;

            case "GENERAL2":
                if (examOrder === 'VERBAL_QUANT') {
                    if(timer.remainingTime && timer.remainingTime <= 9600 && timer.remainingTime > 7800) {
                        // console.log("w1");
                        if (index > 1) setDir(1.5)
                    }
                    else if(timer.remainingTime && timer.remainingTime <= 7800 && timer.remainingTime > 6000) {
                        // console.log("v1");
                        if (index <= 1) {
                            setDir(1.5)
                        } else if (index > 21) {
                            setDir(21)
                        }
                    }
                    else if(timer.remainingTime && timer.remainingTime <= 6000 && timer.remainingTime > 3900) {
                        // console.log("q1");
                        if (index <= 21) {
                            setDir(21)
                        } else if (index > 41) {
                            setDir(41)
                        }
                    }
                    else if(timer.remainingTime && timer.remainingTime <= 3900 && timer.remainingTime > 2100) {
                        // console.log("v2");
                        if (index <= 41) {
                            setDir(41)
                        } else if (index > 61) {
                            setDir(61)
                        }
                    }
                    else if(timer.remainingTime && timer.remainingTime <= 2100 && timer.remainingTime > 0) {
                        // console.log("q2");
                        if (index <= 61) {
                            setDir(61)
                        } else if (index > 81) {
                            setDir(80)
                        }
                    }
                } else {
                    //quantVerbal
                    if(timer.remainingTime && timer.remainingTime <= 9600 && timer.remainingTime > 7800) {
                        // console.log("w1");
                        if (index > 1) setDir(1.5)
                    }
                    else if(timer.remainingTime && timer.remainingTime <= 7800 && timer.remainingTime > 5700) {
                        // console.log("q1");
                        if (index <= 1) {
                            setDir(1.5)
                        } else if (index > 21) {
                            setDir(21)
                        }
                    }
                    else if(timer.remainingTime && timer.remainingTime <= 5700 && timer.remainingTime > 3900) {
                        // console.log("v1");
                        if (index <= 21) {
                            setDir(21)
                        } else if (index > 41) {
                            setDir(41)
                        }
                    }
                    else if(timer.remainingTime && timer.remainingTime <= 3900 && timer.remainingTime > 1800) {
                        // console.log("q2");
                        if (index <= 41) {
                            setDir(41)
                        } else if (index > 61) {
                            setDir(61)
                        }
                    }
                    else if(timer.remainingTime && timer.remainingTime <= 1800 && timer.remainingTime > 0) {
                        // console.log("v2");
                        if (index <= 61) {
                            setDir(61)
                        } else if (index > 81) {
                            setDir(80)
                        }
                    }
                }
                
                break;
        }
      }
      if (timer && type === 'real' && timer.remainingTime === 0) {
        if (isWritingSection(index, examType)) {
          setDir(92);
        } else {
          setDir(80);
        }
      }
      //timer
      const shouldPauseTimer = dir >= 0 && dir !== 90;
      if (shouldPauseTimer) {
        if (timer && !timer.paused) {
          dispatch(pauseTimer({ id:`timer-${userExam}-${type}` }));
        }
      } else {
        if (timer && timer.paused) {
          dispatch(resumeTimer({ id:`timer-${userExam}-${type}` }));
        }
      }

      //chiee?
      if(timer && dir === 80 && timer.remainingTime !== 0 && index < 82) setDir(0)
    })

    const bulkSave = async () => {
        if(answer.answer && answer.answer !== ""){
            await createAnswer(answer)
        }
    }

    const isEndOfSection = (currentIndex: number, totalQuestions: number, currentExamType: string): boolean => {
        switch (currentExamType) {
            case 'GENERAL':
                return currentIndex === 20 || currentIndex === 40 || currentIndex === 60 || currentIndex === 80;
            case 'GENERAL1':
                return currentIndex === 1 || currentIndex === 13 || currentIndex === 25 || currentIndex === 40 || currentIndex === 55;
            case 'GENERAL2':
                return currentIndex === 1 || currentIndex === 21 || currentIndex === 41 || currentIndex === 61 || currentIndex === 81;
            case 'VERBAL':
            case 'QUANT':
            case 'WRITING':
                return currentIndex === totalQuestions;
            default:
                return false;
        }
    };

    const isWritingSectionEnd = (currentIndex: number, totalQuestions: number, currentExamType: string): boolean => {
        if (currentExamType === 'WRITING') {
            return currentIndex === totalQuestions;
        }
        if (currentExamType === 'GENERAL1' || currentExamType === 'GENERAL2') {
            return currentIndex === 1;
        }
        return false;
    };

    function isWritingSection(currentIndex: number, currentExamType: string): boolean {
        if (currentExamType === 'WRITING') return true;
        if (currentExamType === 'GENERAL1' || currentExamType === 'GENERAL2') return currentIndex === 1;
        return false;
    }

    const saveAnswer = async (next: string) => {
        try {
            if(answer.answer && answer.answer !== ""){
                await createAnswer(answer)
                setKey(resetKey + 1);
            }
            if (
                next === "next" &&
                type === "real" &&
                dir < 0 &&
                timer &&
                typeof timer.remainingTime === "number" &&
                timer.remainingTime > 0
            ) {
                if (isWritingSectionEnd(index, end, examType)) {
                    setDir(91);
                    setKey(resetKey + 1);
                    return;
                }
                if (isEndOfSection(index, end, examType)) {
                    setDir(90);
                    setKey(resetKey + 1);
                    return;
                }
            }
            if(next === "next") {
                if (index !== end) {
                    if (dir === 80) {
                        await finishExam(id); 
                        setDir(0)
                        navigate(`/panel/user-exams`)
                        navigate(0)
                    }
                    else if (dir >= 0) {
                        switch (dir) {
                            case 0:
                                if (type === 'real') {
                                    if (examType === 'GENERAL') setDir(1)
                                    else if(['GENERAL1', 'GENERAL2'].includes(examType)) setDir(0.5)
                                    else setDir(-1)
                                } 
                                else setDir(-1)
                                navigate(`/panel/exam/${type}/${id}/1`)
                            break;
                            case 0.5:
                                setDir(-1)
                                navigate(`/panel/exam/${type}/${id}/1`)
                            break;
                            case 1:
                                setDir(-1)
                                navigate(`/panel/exam/${type}/${id}/1`)
                            break;
                            case 1.5:
                                if (examType === 'GENERAL1') {
                                    if (timer && timer.remainingTime && timer.remainingTime >= 5280) 
                                        dispatch(setTimer({ id: `timer-${userExam}-${type}`, remainingTime: 5280 }));
                                } else {
                                    if (timer && timer.remainingTime && timer.remainingTime >= 7800) 
                                        dispatch(setTimer({ id: `timer-${userExam}-${type}`, remainingTime: 7800 }));
                                }
                                setDir(-1)
                                navigate(`/panel/exam/${type}/${id}/2`)
                            break;
                            case 21:
                                if (examType === 'GENERAL') {
                                    if (timer && timer.remainingTime && timer.remainingTime >= 6000) 
                                        dispatch(setTimer({ id: `timer-${userExam}-${type}`, remainingTime: 6000 }));
                                    setDir(-1)
                                    navigate(`/panel/exam/${type}/${id}/21`)
                                }
                                else if (examType === 'GENERAL1') {
                                    if (examOrder === 'VERBAL_QUANT') {
                                        if (timer && timer.remainingTime && timer.remainingTime >= 4200) 
                                            dispatch(setTimer({ id: `timer-${userExam}-${type}`, remainingTime: 4200 }));
                                    } else {
                                        if (timer && timer.remainingTime && timer.remainingTime >= 4020) 
                                            dispatch(setTimer({ id: `timer-${userExam}-${type}`, remainingTime: 4020 })); }
                                    setDir(-1)
                                    navigate(`/panel/exam/${type}/${id}/14`)
                                }
                                else if (examType === 'GENERAL2') {
                                    if (examOrder === 'VERBAL_QUANT') {
                                        if (timer && timer.remainingTime && timer.remainingTime >= 6000) 
                                            dispatch(setTimer({ id: `timer-${userExam}-${type}`, remainingTime: 6000 }));
                                    } else {
                                        if (timer && timer.remainingTime && timer.remainingTime >= 5700) 
                                            dispatch(setTimer({ id: `timer-${userExam}-${type}`, remainingTime: 5700 })); }
                                    setDir(-1)
                                    navigate(`/panel/exam/${type}/${id}/22`)
                                }
                            break;
                            case 41:
                                if (examType === 'GENERAL') {
                                    if (timer && timer.remainingTime && timer.remainingTime >= 3900) 
                                        dispatch(setTimer({ id: `timer-${userExam}-${type}`, remainingTime: 3900 }));
                                    setDir(-1)
                                    navigate(`/panel/exam/${type}/${id}/41`)
                                }
                                else if (examType === 'GENERAL1') {
                                    if (timer && timer.remainingTime && timer.remainingTime >= 2940) 
                                        dispatch(setTimer({ id: `timer-${userExam}-${type}`, remainingTime: 2940 }));
                                    setDir(-1)
                                    navigate(`/panel/exam/${type}/${id}/26`)
                                }
                                else if (examType === 'GENERAL2'){
                                    if (timer && timer.remainingTime && timer.remainingTime >= 3900) 
                                        dispatch(setTimer({ id: `timer-${userExam}-${type}`, remainingTime: 3900 }));
                                    setDir(-1)
                                    navigate(`/panel/exam/${type}/${id}/42`)
                                }
                            break;
                            case 61:
                                if (examType === 'GENERAL') {
                                    if (timer && timer.remainingTime && timer.remainingTime >= 2100) 
                                        dispatch(setTimer({ id: `timer-${userExam}-${type}`, remainingTime: 2100 }));
                                    setDir(-1)
                                    navigate(`/panel/exam/${type}/${id}/61`)
                                }
                                else if (examType === 'GENERAL1') {
                                    if (examOrder === 'VERBAL_QUANT') {
                                        if (timer && timer.remainingTime && timer.remainingTime >= 1560) 
                                            dispatch(setTimer({ id: `timer-${userExam}-${type}`, remainingTime: 1560 }));
                                    } else {
                                        if (timer && timer.remainingTime && timer.remainingTime >= 1380) 
                                            dispatch(setTimer({ id: `timer-${userExam}-${type}`, remainingTime: 1380 })); }
                                    setDir(-1)
                                    navigate(`/panel/exam/${type}/${id}/41`)
                                }
                                else if (examType === 'GENERAL2'){
                                    if (examOrder === 'VERBAL_QUANT') {
                                        if (timer && timer.remainingTime && timer.remainingTime >= 2100) 
                                            dispatch(setTimer({ id: `timer-${userExam}-${type}`, remainingTime: 2100 }));
                                    } else {
                                        if (timer && timer.remainingTime && timer.remainingTime >= 1800) 
                                            dispatch(setTimer({ id: `timer-${userExam}-${type}`, remainingTime: 1800 })); }
                                    setDir(-1)
                                    navigate(`/panel/exam/${type}/${id}/62`)
                                }
                            break;
                            default:
                                navigate(`/panel/exam/${type}/${id}/${index+1}`)
                            break;
                        }
                    }
                    else navigate(`/panel/exam/${type}/${id}/${index+1}`)
                }
                else {
                    const win = window.confirm('آیا آزمون شما به اتمام رسیده است؟') 
                    if (win) {
                        await finishExam(id); 
                        navigate(`/panel/user-exams`)
                        navigate(0)
                    }
                }
            }
            else navigate(`/panel/exam/${type}/${id}/${index-1}`)
            
            
        } catch (err:any){
            console.log(err);
            // const message = !err.data ? '' : Array.isArray(err.data.message) ? err.data.message[0] : err.data.message
        }
    }

    const isBackDisabled = (index: number, examType: string): boolean => {
        if (index === 0) return true;

        switch (examType) {
            case 'GENERAL':
                return index % 20 === 1;
            case 'GENERAL2':
                return index === 1 || index % 20 === 2;
            case 'GENERAL1':
                return index === 1 || index === 2 || index === 14 || index === 26 || index === 41;
            default:
                return false;
        }
    }

    const handleReset = () => {
        const id = `timer-${userExam}-${type}`;
        dispatch(resetTimer({ id }));
        return true;
    };

    const handleContinueFromSectionEnd = async () => {
        // برای صفحه End of Section در حالت real
        if (type !== 'real') return;

        try {
            const goToNextQuestion = (nextIndex: number) => {
                setDir(-1);
                navigate(`/panel/exam/${type}/${id}/${nextIndex}`);
            };

            if (isWritingSection(index, examType) && dir === 91) {
                setDir(92);
                setKey(resetKey + 1);
                return;
            }

            if (examType === 'GENERAL') {
                if (index >= end) {
                    const win = window.confirm('آیا آزمون شما به اتمام رسیده است؟');
                    if (win) {
                        await finishExam(id);
                        navigate(`/panel/user-exams`);
                        navigate(0);
                    }
                } else if (index === 20) {
                    goToNextQuestion(21);
                } else if (index === 40) {
                    goToNextQuestion(41);
                } else if (index === 60) {
                    goToNextQuestion(61);
                }
            } else if (examType === 'GENERAL1') {
                if (index >= end) {
                    const win = window.confirm('آیا آزمون شما به اتمام رسیده است؟');
                    if (win) {
                        await finishExam(id);
                        navigate(`/panel/user-exams`);
                        navigate(0);
                    }
                } else if (index === 1) {
                    goToNextQuestion(2);
                } else if (index === 13) {
                    goToNextQuestion(14);
                } else if (index === 25) {
                    goToNextQuestion(26);
                } else if (index === 40) {
                    goToNextQuestion(41);
                }
            } else if (examType === 'GENERAL2') {
                if (index >= end) {
                    const win = window.confirm('آیا آزمون شما به اتمام رسیده است؟');
                    if (win) {
                        await finishExam(id);
                        navigate(`/panel/user-exams`);
                        navigate(0);
                    }
                } else if (index === 1) {
                    goToNextQuestion(2);
                } else if (index === 21) {
                    goToNextQuestion(22);
                } else if (index === 41) {
                    goToNextQuestion(42);
                } else if (index === 61) {
                    goToNextQuestion(62);
                }
            } else {
                // آزمون‌های تک سکشنی (VERBAL, QUANT, WRITING و ...)
                const win = window.confirm('آیا آزمون شما به اتمام رسیده است؟');
                if (win) {
                    await finishExam(id);
                    navigate(`/panel/user-exams`);
                    navigate(0);
                }
            }
        } catch (err) {
            console.log(err);
        }
    };

    return(
        <>
        <header dir='ltr' className="d-flex align-items-center bg-dark py-1 border-bottom border-danger border-2 text-white" data-bs-theme="dark">
            <div className="pe-4">
                <img src={logo} style={{maxHeight: "70px"}} alt="logo"></img>
                <h6 className="d-none d-md-inline text-white me-4">{title}{type === "test" && " (Practice Mode)"}</h6>
            </div>
            
            <ul className="me-auto mt-1 mb-0 ms-4 d-flex align-items-center list-unstyled overflow-scroll">

                {review ? (
                    <>
                        <li className="ms-4">
                            <button
                                onClick={() => { setReview(false); setKey(resetKey + 1); }}
                                className="btn py-2 px-3 text-center fw-light border border-secondary"
                                style={{backgroundColor:"#575658"}}
                            >
                                Return
                                <FontAwesomeIcon icon="arrow-left" className='d-block mx-auto'/>
                            </button>
                        </li>
                        <li className="ms-2">
                            <button
                                onClick={() => {
                                    if (!reviewSelectedOrder) return;
                                    setDir(-1);
                                    setReview(false);
                                    setKey(resetKey + 1);
                                    navigate(`/panel/exam/${type}/${id}/${reviewSelectedOrder}`);
                                }}
                                disabled={!reviewSelectedOrder}
                                className="btn py-2 px-3 text-center fw-light border border-secondary"
                                style={{backgroundColor:"#3A669C", opacity: reviewSelectedOrder ? 1 : 0.6}}
                            >
                                Go to Question
                                <FontAwesomeIcon icon="arrow-right" className='d-block mx-auto'/>
                            </button>
                        </li>
                    </>
                ) : help ? (
                    <>
                        <li className="ms-4">
                            <button
                                onClick={() => { setHelp(false); setKey(resetKey + 1); }}
                                className="btn py-2 px-3 text-center fw-light border border-secondary"
                                style={{backgroundColor:"#575658"}}
                            >
                                Return
                                <FontAwesomeIcon icon="arrow-left" className='d-block mx-auto'/>
                            </button>
                        </li>
                    </>
                ) : dir === 90 && type === 'real' ? (
                    <>
                        <li className="ms-4">
                            <button
                                className="btn py-2 px-3 text-center fw-light border border-secondary"
                                style={{backgroundColor:"#575658"}}
                                onClick={() => { setReview((prev:boolean) => !prev); }}
                            >
                                Review
                                <FontAwesomeIcon icon="sitemap" className='d-block mx-auto'/>
                            </button>
                        </li>
                        <li className="ms-2">
                            <button
                                className="btn py-2 px-3 text-center fw-light border border-secondary"
                                style={{backgroundColor:"#3A669C"}}
                                onClick={() => { setDir(-1); setKey(resetKey + 1); }}
                            >
                                Return
                                <FontAwesomeIcon icon="arrow-left" className='d-block mx-auto'/>
                            </button>
                        </li>
                        <li className="ms-2">
                            <button
                                className="btn py-2 px-3 text-center fw-light border border-secondary"
                                style={{backgroundColor:"#3A669C"}}
                                onClick={handleContinueFromSectionEnd}
                            >
                                Continue
                                <FontAwesomeIcon icon="arrow-right" className='d-block mx-auto'/>
                            </button>
                        </li>
                    </>
                ) : dir === 91 && type === 'real' ? (
                    <>
                        <li className="ms-4">
                            <button
                                className="btn py-2 px-3 text-center fw-light border border-secondary"
                                style={{backgroundColor:"#3A669C"}}
                                onClick={() => { setDir(-1); setKey(resetKey + 1); }}
                            >
                                Return
                                <FontAwesomeIcon icon="arrow-left" className='d-block mx-auto'/>
                            </button>
                        </li>
                        <li className="ms-2">
                            <button
                                className="btn py-2 px-3 text-center fw-light border border-secondary"
                                style={{backgroundColor:"#3A669C"}}
                                onClick={handleContinueFromSectionEnd}
                            >
                                Continue
                                <FontAwesomeIcon icon="arrow-right" className='d-block mx-auto'/>
                            </button>
                        </li>
                    </>
                ) : dir === 92 && type === 'real' ? (
                    <>
                        <li className="ms-4">
                            <button
                                className="btn py-2 px-3 text-center fw-light border border-secondary"
                                style={{backgroundColor:"#3A669C"}}
                                onClick={handleContinueFromSectionEnd}
                            >
                                Continue
                                <FontAwesomeIcon icon="arrow-right" className='d-block mx-auto'/>
                            </button>
                        </li>
                    </>
                ) : (
                    <>
                        <li className="ms-4">
                            <button onClick={() => {window.confirm('Are you sure you want to exit?')  && handleReset() && navigate("/panel/exams");setKey(resetKey + 1);} } className="btn py-2 px-3 text-center fw-light border border-secondary" style={{backgroundColor:"#694C61"}}>
                                Quit w/Save
                                <FontAwesomeIcon icon="save" className='d-block mx-auto'/>
                            </button>
                        </li>

                        {isQuantNow() && (
                        <li className="ms-2">
                            <button className="btn py-2 px-3 text-center fw-light border border-secondary" onClick={() => setCalc(calc => !calc)} style={{backgroundColor:"#575658"}}>
                                Calc
                                <FontAwesomeIcon icon="calculator" className='d-block mx-auto'/>
                            </button>
                        </li>
                        )}
                        <li className="ms-4">
                            <button className="btn py-2 px-3 text-center fw-light border border-secondary" style={{backgroundColor:"#575658"}} data-bs-toggle="modal" data-bs-target="#infoModal">
                                Info
                                <FontAwesomeIcon icon="info-circle" className='d-block mx-auto'/>
                            </button>
                        </li>

                        {dir === -1 && <li className="ms-2">
                            <button className="btn py-2 px-3 text-center fw-light border border-secondary" onClick={() => {bulkSave();togglePin()}} style={pin.status === 'CHECK' ? { backgroundColor:"green"} : {backgroundColor:"#575658"}}>
                                Mark
                                <FontAwesomeIcon icon="bookmark" className='d-block mx-auto'/>
                            </button>
                        </li>}
                        
                        {dir < 0 && !(examType === "GENERAL2" && index === 1) && !(examType === "GENERAL1" && index === 1) && (
                            <>
                                <li className="ms-2">
                                    <button className="btn py-2 px-3 text-center fw-light border border-secondary"  onClick={() => {setReview((prev:boolean) => !prev)}} style={{backgroundColor:"#575658"}}>
                                        Review
                                        <FontAwesomeIcon icon="sitemap" className='d-block mx-auto'/>
                                    </button>
                                </li>
                                <li className="ms-2">
                                    <button
                                        className="btn py-2 px-3 text-center fw-light border border-secondary"
                                        onClick={() => { setHelp(true); setKey(resetKey + 1); }}
                                        style={{backgroundColor:"#575658"}}
                                    >
                                        Help
                                        <FontAwesomeIcon icon="question-circle" className='d-block mx-auto'/>
                                    </button>
                                </li>
                            </>
                        )}
                        <li className="ms-2">
                            <button onClick={() => saveAnswer("perv")} disabled={dir >= 0 ? true : isBackDisabled(index, examType)} className={`btn py-2 px-3 text-center fw-light border border-secondary`} style={{backgroundColor:"#3A669C"}}>
                                Back
                                <FontAwesomeIcon icon="step-backward" className='d-block mx-auto'/>
                            </button>
                        </li>
                        <li className="">
                            <button onClick={() => saveAnswer("next")} className="btn py-2 px-3 text-center fw-light border border-secondary" style={{backgroundColor:"#3A669C"}}>
                                {index === end ? "Finish" : dir >= 0 ? dir === 80 ? "Finish" : "Continue" : "Next"}
                                <FontAwesomeIcon icon="step-forward" className='d-block mx-auto'/>
                            </button>
                        </li>
                    </>
                )}
            </ul>
        </header>
        <div className="modal fade" dir='ltr' id="infoModal" tabIndex={-1} aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div className="modal-dialog modal-dialog-scrollable">
                <div className="modal-content">
                <div className="modal-header">
                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>

                    <h1 className="modal-title fs-5" id="exampleModalLabel">Exam Info</h1>
                </div>
                <div className="modal-body">
                    {safeParseHtml(info)}
                </div>
                <div className="modal-footer">
                    <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                </div>
                </div>
            </div>
        </div>

        {calc && <Calculator close={setCalc}/>}
        </>
   )
}
